// Dependecies
import { useState, useEffect } from 'react';
import * as moment from 'moment';

// Store
import user from '../../store/user';

function useBubbleCharts(plate) {
  const [userStore] = user();
  const [bubbleData, useSetBubbleData] = useState([]);
  const [year] = useState(moment().format('Y'));

  useEffect(() => {
    if (userStore.token) {
      const getRadar = async () => {
        const jsons = {
          licensePlate: plate,
        };
        const options = {
          method: 'POST',
          body: JSON.stringify(jsons),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `bearer ${userStore.token}`,
          },
        };
        const response = await fetch('/api/bread/jwt/services/static/bubble_dashboard', options);
        const newData = await response.json();
        if (response.status === 200) {
          const newDataJson = Object.values(newData.projection);
          useSetBubbleData(newDataJson);
        }
      };
      getRadar();
    }
  }, [userStore.token]);

  return {
    bubbleData,
    year,
  };
}

export default useBubbleCharts;
